function n(){return"2.21.1"}export{n as getVersion};
